// 🔹 Stylesheets
import './ProgramUserSelect.component.css';

// 🔹 React Core
import React, { FC } from 'react';

// 🔹 UI Component Libraries
import { Checkbox } from 'antd';
import type { CheckboxChangeEvent } from 'antd/es/checkbox';

// 🔹 Types
import type { User } from 'src/config/traniner.config';

interface ProgramUserSelectProps {
  users: User[];
  selectedIds: string[];
  toggleUser: (id: string) => void;
}

const ProgramUserSelect: FC<ProgramUserSelectProps> = ({ users, selectedIds, toggleUser }) => {
  return (
    <div className="user-select-container">
      {users.map((user) => {
        const checked = selectedIds.includes(user._id);

        return (
          <div key={user._id} className={`user-item ${checked ? 'active' : ''}`}>
            <Checkbox
              checked={checked}
              onChange={(e: CheckboxChangeEvent) => {
                e.stopPropagation(); // prevent double trigger
                toggleUser(user._id);
              }}
            >
              <img src={user.avatar} alt={user.name} className="avatar" />

              <div className="user-info">
                <span className="name">{user.name}</span>
              </div>
            </Checkbox>
          </div>
        );
      })}
    </div>
  );
};

export default ProgramUserSelect;
